import axios from 'axios'
import store from '@/store'

// URL base do backend Spring Boot (rede_marketing)
const baseURL = process.env.VUE_APP_REDE_MARKETING_URL || 'https://rede.diariodetreino.com/api/'

const redeMarketingApi = axios.create({ baseURL, timeout: 15000 })

// Interceptor de request: anexa o JWT do rede_marketing
redeMarketingApi.interceptors.request.use(
  (config) => {
    const jwt = store.getters.RedeMarketingJwt
    if (jwt) {
      config.headers['Authorization'] = `Bearer ${jwt}`
    }
    return config
  },
  (error) => Promise.reject(error),
)

// Interceptor de response: em 401 tenta renovar o JWT via token Sanctum
let refreshingPromise = null

redeMarketingApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config
    if (!error.response || error.response.status !== 401 || original._retry) {
      return Promise.reject(error)
    }
    original._retry = true
    const sanctumToken = store.getters.ApiToken
    if (!sanctumToken) return Promise.reject(error)

    try {
      if (!refreshingPromise) {
        refreshingPromise = redeMarketingApi
          .post('auth/login', { sanctumToken })
          .finally(() => {
            const p = refreshingPromise
            refreshingPromise = null
            return p
          })
      }
      const loginResp = await refreshingPromise
      store.commit('SET_REDE_MARKETING_AUTH', {
        jwt: loginResp.data.token,
        membroId: loginResp.data.membroId,
        codigoIndicacao: loginResp.data.codigoIndicacao,
      })
      original.headers['Authorization'] = `Bearer ${loginResp.data.token}`
      return redeMarketingApi(original)
    } catch (refreshErr) {
      store.commit('SET_REDE_MARKETING_AUTH', { jwt: null, membroId: null, codigoIndicacao: null })
      return Promise.reject(refreshErr)
    }
  },
)

export default {
  // ========== AUTH ==========
  Login(sanctumToken) {
    return redeMarketingApi.post('auth/login', { sanctumToken })
  },
  Me() {
    return redeMarketingApi.get('auth/me')
  },

  // ========== MEMBROS ==========
  BuscarMembro(id) {
    return redeMarketingApi.get(`membros/${id}`)
  },
  BuscarMembroPorLaravelId(laravelUserId) {
    return redeMarketingApi.get(`membros/laravel/${laravelUserId}`)
  },

  // ========== GENEALOGIA ==========
  BuscarNo(membroId) {
    return redeMarketingApi.get(`genealogia/${membroId}`)
  },
  Downline(membroId) {
    return redeMarketingApi.get(`genealogia/${membroId}/downline`)
  },
  Upline(membroId) {
    return redeMarketingApi.get(`genealogia/${membroId}/upline`)
  },
  ContarDiretos(membroId) {
    return redeMarketingApi.get(`genealogia/${membroId}/diretos/count`)
  },

  // ========== RANKS ==========
  RankAtual(membroId) {
    return redeMarketingApi.get(`ranks/membro/${membroId}/atual`)
  },

  // ========== PUBLICO (cadastro via link de indicacao) ==========
  BuscarPatrocinadorPublico(codigo) {
    return redeMarketingApi.get(`public/patrocinador/${codigo}`)
  },
  CadastroPublico(data) {
    return redeMarketingApi.post('public/cadastro', data)
  },
}
